import { Versions } from '../../models/Versions';

export abstract class IVersionsRepo {
	abstract loadVersions(): Promise<Versions>;
}
